import {
  LoadingContainer,
  LegacyPage,
  Model,
  Panels,
  Bar,
  Modal,
  Input,
  Form,
  Textarea,
  Select,
  DateInput,
  NumericInput,
} from 'peach/components'
import { useParams } from 'peach/router'

import { useGetLoanAdvances, useCreateLoanAdvance } from 'core/types'

import { defaultAdvance } from './defaultAdvance'

const LoanAdvances = () => {
  const { personId, loanId } = useParams<{
    personId?: string
    loanId?: string
  }>()

  const {
    data: advances,
    isLoading,
    error,
  } = useGetLoanAdvances({
    personId,
    loanId,
  })

  const { mutateAsync: createLoanAdvance } = useCreateLoanAdvance({
    personId,
    loanId,
  })

  return (
    <Panels header={<Bar title='Advances' />}>
      <Modal
        initialValue={defaultAdvance}
        onSubmit={async (options) => {
          await createLoanAdvance(options)
        }}
        title='Create Loan Advance'
      >
        <Input formKey='externalId' />
        <Select
          formKey='status'
          nullable
          options={['scheduled', 'settled', 'pending', 'canceled']}
        />
        <DateInput formKey='advanceDate' />
        <NumericInput formKey='amount' />
        <Form.Provider formKey='advanceDetails'>
          <Input formKey='description' />
          <Input formKey='pointOfSaleType' />
          <Input formKey='categoryId' />
          <Input formKey='merchantId' />
          <Input formKey='merchantName' />
          <Textarea.Json formKey='metadata' />
        </Form.Provider>
      </Modal>
      <LoadingContainer error={error} isLoading={isLoading}>
        <LegacyPage.Full>
          <Model.Item json={advances} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanAdvances
